import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import TDPTableSelectRedux from "../../TDP/TDPTableSelectRedux";
import TurmaDisciplinaProfessorProfileRedux from "../../TDP/TurmaDisciplinaProfessorProfileRedux";
import { ADMIN } from "../../Usuario/Perfil";
import Container from "../../UI/Container";
import AusenciaCompensadaTable from "./AusenciaCompensadaTable";

export default function AusenciaCompensadaContainer() {
  const tdp = useSelector((state) => state.tdp);
  const usuario = useSelector((state) => state.usuario);
  const isAdmin = usuario?.perfil === ADMIN;

  return (
    <Container>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        spacing={2}
        mb={3}
      >
        <Box>
          <Typography variant="h6">Aluno Frequência</Typography>
          <Typography variant="body2" color="text.secondary">
            {tdp
              ? "Lance as ausências compensadas dos alunos por bimestre."
              : "Selecione a turma e disciplina para lançar as ausências compensadas."}
          </Typography>
        </Box>
        {isAdmin && (
          <Button variant="outlined" startIcon={<PlaylistAddCheckIcon />} component={Link} to="/aluno-frequencia-lote">
            Frequência em Lote
          </Button>
        )}
      </Stack>

      {tdp ? (
        <Stack spacing={3}>
          <TurmaDisciplinaProfessorProfileRedux />
          <AusenciaCompensadaTable tdp={tdp} isAdmin={isAdmin} />
        </Stack>
      ) : (
        <TDPTableSelectRedux />
      )}
    </Container>
  );
}
